export const CLIENTE_UPDATE_VALUE = 'CLIENTE_UPDATE_VALUE';
export const AUTH_UPDATE = 'AUTH_UPDATE';
export const USER_LOGOUT = 'USER_LOGOUT';
